module.exports = __webpack_public_path__ + "img/dark_meal.85108dfa.png";